import { useState } from "react";
import { LayoutDashboard, CircleDollarSign, Newspaper, Menu, X } from 'lucide-react';
import { Switch } from "radix-ui";


export function Sidebar({ activeTab, setActiveTab }) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isDark, setIsDark] = useState(document.documentElement.classList.contains('dark'));

    const items = [
        { icon: <LayoutDashboard />, label: "Dashboard"},
        { icon: <CircleDollarSign />, label: "Market" },
        { icon: <Newspaper />, label: "News" },
    ];

    const toggleTheme = () => {
        document.documentElement.classList.toggle('dark');
        setIsDark(!isDark);
    };


  return (
    <div style={{boxShadow: "4px 0 6px -1px rgba(0,0,0,0.1)"}} className={
  `relative bg-color1 dark:border-r dark:border-zinc-800 transition-all duration-300 ${isCollapsed ? "w-20" : "w-64"}`}>  
        <header className={`py-4 border-b border-zinc-300 dark:border-zinc-800 flex gap-4 items-center ${isCollapsed ? "justify-center" : "justify-between mr-2"}`}>
            {!isCollapsed && (
                <img className='mx-4' src='/images/logo.png' alt='marketmint logo'/>
            )}
            <button
                type="button"
                onClick={() => setIsCollapsed(!isCollapsed)}
                className="group p-2 rounded hover:bg-[#00F4AA] transition h-[24px] w-[24px] box-content flex justify-center">
                {isCollapsed ? <Menu className="w-6 h-6 group-hover:text-black" /> : <X className="w-6 h-6 group-hover:text-black" />}
            </button>
        </header>
            <nav className='p-4'>
                <ul>
                    {items.map(({ icon, label }) => (
                    <div className={activeTab === label ? 'active' : 'inactive'} key={label}
                    onClick={() => setActiveTab(label)}>
                        {icon} {!isCollapsed && label}
                    </div>
                    ))}
                </ul>
            </nav>
            {!isCollapsed && (
                <div className="flex justify-center gap-4 fixed bottom-5 left-5">
                    <Switch.Root checked={isDark} onCheckedChange={toggleTheme} defaultChecked id="dark-mode" 
                        className="SwitchRoot w-11 h-6 data-[state=checked]:bg-primary dark:data-[state=checked]:bg-primary bg-gray-300 dark:bg-gray-700 rounded-full relative transition-colors">
                        <Switch.Thumb className="SwitchThumb block w-5 h-5 bg-white rounded-full shadow-md transition-transform translate-x-1 data-[state=checked]:translate-x-5"/>
                    </Switch.Root>
                    <label
                        className="Label"
                        htmlFor="dark-mode"
                        style={{ paddingRight: 15 }}
                    >Dark mode</label>
                </div>
            )}
    </div>
  );
}